module.exports = __webpack_public_path__ + "static/ae2-4125fad32fc5a16aa6f07537f00a6d11.svg";